(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "67d241b219d540ecc00b2b12";
              window.beaePageSetting.pageTitle = "landing home page banner"; 
              window.beaePageSetting.pageType = "section";

          let js_VK84P1LV = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-1gilgm9ysection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1gilgm9y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1gilgm9y');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1gilgm9y: ', ex)
      };
    

      try {
        let argid = 'beae-1gilgm9ysection-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1gilgm9y',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1gilgm9y');
        args.el = args.els[0];
        ((data
) => { const video = data.el.querySelector(".beae-section-background-video video");
const unmuteBtn = data.el.querySelector('.unmute-btn');
const muteBtn = data.el.querySelector('.mute-btn');
muteBtn.parentElement.style.display = 'none';

unmuteBtn.addEventListener('click', () => {
    muteBtn.parentElement.style.display = 'block';
    unmuteBtn.parentElement.style.display = 'none';
    video.muted = false;
    video.play();
});

muteBtn.addEventListener('click', () => {
    unmuteBtn.parentElement.style.display = 'block';
    muteBtn.parentElement.style.display = 'none';
    video.muted = true;
    video.play();
}); 

data.el.querySelector('.unmute-btn a').removeAttribute('href');
data.el.querySelector('.mute-btn a').removeAttribute('href'); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1gilgm9y: ', ex)
      };
    

      try {
        let argid = 'beae-9lzgg7lcblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9lzgg7lc',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9lzgg7lc');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(A=>{let O=A==null?void 0:A.getAttribute("href");A&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&A.addEventListener("click",z=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),z.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9lzgg7lc: ', ex)
      };
    

      try {
        let argid = 'beae-s26kiprablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-s26kipra',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-s26kipra');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(A=>{let O=A==null?void 0:A.getAttribute("href");A&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&A.addEventListener("click",z=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),z.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-s26kipra: ', ex)
      };
    

      try {
        let argid = 'beae-tfc10fe4section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tfc10fe4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tfc10fe4');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tfc10fe4: ', ex)
      };
    

      try {
        let argid = 'beae-tfc10fe4section-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tfc10fe4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tfc10fe4');
        args.el = args.els[0];
        ((data
) => { const video = data.el.querySelector(".beae-section-background-video video");
const unmuteBtn = data.el.querySelector('.unmute-btn');
const muteBtn = data.el.querySelector('.mute-btn');
muteBtn.parentElement.style.display = 'none';

unmuteBtn.addEventListener('click', () => {
    muteBtn.parentElement.style.display = 'block';
    unmuteBtn.parentElement.style.display = 'none';
    video.muted = false;
    video.play();
});

muteBtn.addEventListener('click', () => {
    unmuteBtn.parentElement.style.display = 'block';
    muteBtn.parentElement.style.display = 'none';
    video.muted = true;
    video.play();
}); 

data.el.querySelector('.unmute-btn a').removeAttribute('href');
data.el.querySelector('.mute-btn a').removeAttribute('href'); })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tfc10fe4: ', ex)
      };
    

      try {
        let argid = 'beae-s7flpul3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-s7flpul3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-s7flpul3');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(A=>{let O=A==null?void 0:A.getAttribute("href");A&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&A.addEventListener("click",z=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),z.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-s7flpul3: ', ex)
      };
    

      try {
        let argid = 'beae-tm8ib1kbblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tm8ib1kb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tm8ib1kb');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(A=>{let O=A==null?void 0:A.getAttribute("href");A&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&A.addEventListener("click",z=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),z.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tm8ib1kb: ', ex)
      };
    }; if (window.BEAEBASE) {js_VK84P1LV()} else {window.BEAEPAGEJS.push(js_VK84P1LV)} })(); 